var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.neighbourhoodGLTF && _vm.neighbourhoodLabels.length)?_c('neighbourhood',{attrs:{"gltf":_vm.neighbourhoodGLTF,"labels":_vm.neighbourhoodLabels,"total-stars":_vm.totalStars}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }